
import { Component, Watch } from 'vue-property-decorator';
import Booking from '@/views/Booking.vue';
import { mapState } from 'vuex';

@Component({
   computed: {
      ...mapState({
         beforeunload: (s: any) => s.beforeunload,
         loadBeforeunload: (s: any) => s.loadBeforeunload,
      }),
   },

   beforeRouteLeave(to, from, next) {
      // @ts-ignore
      console.log('beforeRouteLeave', this.beforeunload, this.loadBeforeunload);

      // @ts-ignore
      if (this.beforeunload !== this.loadBeforeunload) {
         if (!window.confirm('You have unsaved changes. Are you sure you want to leave this page?')) {
            return;
         }
      }

      const favicon: any = document.querySelector("link[rel~='icon']") as HTMLElement;
      favicon.setAttribute('href', process.env.VUE_APP_PUBLIC_PATH + 'favicon.ico');

      next();
   },
})
export default class BaseEditablePage extends Booking {
   loadBeforeunload!: string;

   beforeunload!: string;

   checkFormStatus(): void {
      //
   }

   beforeDestroy(): void {
      this.removeBeforeUnloadListener();
   }

   onChangeFormListener(event: any) {
      event.preventDefault();
      event.returnValue = '';
   }

   removeBeforeUnloadListener() {
      const favicon: any = document.querySelector("link[rel~='icon']") as HTMLElement;
      favicon.setAttribute('href', process.env.VUE_APP_PUBLIC_PATH + 'favicon.ico');

      window.removeEventListener('beforeunload', this.onChangeFormListener, false);
   }

   addBeforeUnloadListener() {
      const favicon: any = document.querySelector("link[rel~='icon']") as HTMLElement;
      favicon.setAttribute('href', process.env.VUE_APP_PUBLIC_PATH + 'favicon-dot.ico');

      window.addEventListener('beforeunload', this.onChangeFormListener, false);
   }

   @Watch('beforeunload')
   @Watch('loadBeforeunload')
   changeBeforeUnload() {
      if (this.beforeunload.length && this.beforeunload !== this.loadBeforeunload) {
         this.addBeforeUnloadListener();
      } else {
         this.removeBeforeUnloadListener();
      }

      this.checkFormStatus();
   }
}
